<template>
    <div id="announcements-manager">
        <v-card ref="announcementsManager">
            <!-- Navigation -->
            <v-tabs v-model="tab" :background-color="primaryColor" dark fixed-tabs show-arrows>
                <v-tabs-slider></v-tabs-slider>
                <v-tab>
                    ORA Form Intro
                </v-tab>
                <v-tab>
                    ORA Form Presubmit
                </v-tab>
                <v-tab>
                    Dashboard - Student
                </v-tab>
                <v-tab>
                    Dashboard - Admin
                </v-tab>
            </v-tabs>
            <!-- Content -->
            <v-tabs-items v-model="tab">
                <v-tab-item v-for="(item, i) in data" :key="i">
                    <announcements-edit :item="item" :permission="permission" @refreshData="refreshData"
                        @setNotification="setNotification">
                    </announcements-edit>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </div>
</template>

<script>
import AnnouncementsEdit from './Edit';

export default {
    name: 'announcements-manager',
    components: {
        AnnouncementsEdit
    },
    props: {
        data: {
            required: true
        },
        permission: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            tab: null
        }
    },
    methods: {
        refreshData() {
            this.$emit('refreshData');
        },
        setNotification(color, icon, message, status) {
            this.$emit('setNotification', color, icon, message, status);
        }
    },
    computed: {
        primaryColor() {
            return '#5867dd';
        }
    }
}
</script>